import { PageSize } from '@mews-commander/data-access';
import { oneOf } from './func';

export const isSmallPageSize = (pageSize: PageSize): boolean => oneOf(pageSize, PageSize.A5, PageSize.HalfLetter);
